export const updatePayloadChatbotExport = (currentExportPermission, selectedExportPermission, updatePayload) => {
  if (currentExportPermission !== selectedExportPermission) {
    updatePayload.chatbotExportFlag = selectedExportPermission
  }
}

export const updatePayloadChatbotCopy = (currentCopyPastePermission, selectedCopyPastePermission, updatePayload) => {
  if (currentCopyPastePermission !== selectedCopyPastePermission) {
    updatePayload.chatbotCopyFlag = selectedCopyPastePermission
  }
}
export const updatePayloadGroupName = (projectName, updatePayload, setCurrentGroupName) => {
  updatePayload.groupName = projectName.trim()
  setCurrentGroupName(updatePayload.groupName)
}

export const updatePayloadGroupDescription = (currentDescription, projectDescription, updatePayload) => {
  if (currentDescription !== projectDescription) {
    updatePayload.description = projectDescription
  }
}

export const updatePayloadJurisdiction = (currentJurisdiction, selectedJurisdiction, updatePayload) => {
  if (currentJurisdiction.toString() !== selectedJurisdiction.map((element) => element.STATE_ID).toString()) {
    updatePayload.jurisdiction = selectedJurisdiction.map((element) => element.STATE_ID)
  }
}
export const updatePayloadDataAggregation = (currentDataAggregation, selectedDataAggregation, updatePayload) => {
  if (currentDataAggregation.toString() !== selectedDataAggregation?.map((element) => element.key).toString()) {
    updatePayload.dataAggregation = selectedDataAggregation.map((element) => element.key)
  }
}

export const updatePayloadFilters = (currentFilters, selectedFilters, updatePayload) => {
  const newFilterKeys = selectedFilters.map((filter) => filter.FILTER_KEY)

  if (currentFilters.sort().toString() !== newFilterKeys.sort().toString()) {
    updatePayload.filters = newFilterKeys
  }
}

export const updatePayloadUseCases = (currentUseCases, selectedUseCases, updatePayload) => {
  if (
    [...(currentUseCases || [])].sort((a, b) => a - b).toString() !==
    [...(selectedUseCases || [])].sort((a, b) => a - b).toString()
  ) {
    updatePayload.usecase = [...selectedUseCases]
  }
}

export const updatePayloadPersona = (currentPersona, selectedPersona, updatePayload) => {
  if (currentPersona !== selectedPersona) {
    updatePayload.personaFlag = selectedPersona
  }
}

export const updatePayloadBenefits = (selectedBenefits, updatePayload) => {
  updatePayload.benefits = selectedBenefits?.map((element) => element.id) || []
}

export const uploadPayloadWorkforces = (currentWorkforces, selectedWorkforces, updatePayload) => {
  if (currentWorkforces.toString() !== selectedWorkforces.map((element) => element.id).toString()) {
    updatePayload.workforces = selectedWorkforces.map((element) => element.id)
  }
}

export const updatePayloadTrendAnalysis = (currentTrendAnalysis, selectedTrendAnalysis, updatePayload) => {
  if (currentTrendAnalysis !== selectedTrendAnalysis) {
    updatePayload.trendAnalysisFlag = selectedTrendAnalysis
  }
}

export const updatePayloadUserFeedback = (currentUserFeedbackFlag, selectedUserFeedbackFlag, updatePayload) => {
  if (currentUserFeedbackFlag !== selectedUserFeedbackFlag) {
    updatePayload.userFeedbackFlag = selectedUserFeedbackFlag
  }
}

export const updatePayloadChatbot = (currentChatbot, selectedChatbot, updatePayload) => {
  if (currentChatbot !== selectedChatbot) {
    updatePayload.chatbotFlag = selectedChatbot
  }
}
export const updatePayloadExportToggle = (currentExportToggle, selectedExportToggle, updatePayload) => {
  if (currentExportToggle !== selectedExportToggle) {
    updatePayload.exportFlag = selectedExportToggle
  }
}

export const updatePayloadPOI = (currentPOI, selectedPOI, updatePayload) => {
  if (currentPOI.toString() !== selectedPOI.map((element) => element.POI_ID).toString()) {
    updatePayload.pointOfInterest = selectedPOI.map((element) => element.POI_ID)
  }
}
